import GetAvailableDeliveryDay from '@/services/logistics/postcodeService/GetAvailableDeliveryDay';
import GetDeliveryDatesForPostcode from '@/services/logistics/postcodeService/GetDeliveryDatesForPostcode';
import LegacyIsPostcodeDeliverable from '@/services/logistics/postcodeService/LegacyIsPostcodeDeliverable';
import FetchPostcodeDeliverableStatus from '@/services/logistics/postcodeService/FetchPostcodeDeliverableStatus';
import GetFirstDeliveryDayForPostcode from '@/services/logistics/postcodeService/GetFirstDeliveryDayForPostcode';
import LegacyGetFirstDeliveryDayForPostcode from '@/services/logistics/postcodeService/LegacyGetFirstDeliveryDayForPostcode';

export default class PostcodeService {
    /**
     * Get the available delivery day via API for the requested postcode.
     *
     * @param {String} postcode
     *
     * @return {Promise}
     */
    getAvailableDeliveryDay(postcode) {
        return (new GetAvailableDeliveryDay()).handle(postcode);
    }

    /**
     * Get delivery days via API for requested postcode.
     *
     * @param {String} postcode
     * @param {Number} numberOfDeliveryDays
     *
     * @returns {Promise}
     */
    static getDeliveryDatesForPostcode(postcode, numberOfDeliveryDays) {
        return (new GetDeliveryDatesForPostcode()).handle(postcode, numberOfDeliveryDays);
    }

    /**
     * Get the first delivery day via API for requested postcode.
     *
     * @param {String} postcode
     *
     * @returns {String}
     */
    async legacyGetFirstDeliveryDayForPostcode(postcode) {
        return (new LegacyGetFirstDeliveryDayForPostcode()).handle(postcode);
    }

    /**
     * Check if the postcode is deliverable.
     *
     * @param {String} postcode
     *
     * @returns {Boolean}
     */
    async isPostcodeDeliverable(postcode) {
        return (new LegacyIsPostcodeDeliverable()).handle(postcode);
    }

    /**
     * Determine whether we can deliver to this postcode via the API.
     *
     * @param {string} postcode
     *
     * @returns {Promise}
     */
    static fetchPostcodeDeliverableStatus(postcode) {
        return (new FetchPostcodeDeliverableStatus()).handle(postcode);
    }

    /**
     * Get the first delivery day via API for requested postcode.
     *
     * @param {String} postcode
     *
     * @returns {String}
     */
    static GetFirstDeliveryDayForPostcode(postcode) {
        return (new GetFirstDeliveryDayForPostcode()).handle(postcode);
    }
}
